
export { MainContent } from "/home/runner/_work/play/play/apps/play-portal/src/components/layout/MainContent.tsx"